'use client';
import PDPStickyNav from '@repo/ui/src/components/PDPStickyNav';
import ProductPrice from '@src/components/Product/Price';
import AddToCartButton from '@src/components/AddToCartButton';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface MeaterProductNavProps {
  product: MeaterProduct;
  activeVariantId?: string;
  onAddToCart: () => void;
  isAdding: boolean;
  isOutOfStock?: boolean;
}

const MeaterProductNav = ({
  product,
  activeVariantId,
  onAddToCart,
  isAdding,
  isOutOfStock,
}: MeaterProductNavProps) => (
  <PDPStickyNav name={product.title} className="py-2">
    <div className="flex flex-row text-warm-100 mr-5 items-center">
      <ProductPrice
        product={product}
        variantId={activeVariantId}
        color="white"
        variant="h7"
        component="h6"
      />
    </div>
    <AddToCartButton
      onClick={onAddToCart}
      processing={isAdding}
      disabled={!activeVariantId}
      outOfStock={isOutOfStock}
      className="!h-auto !py-3 !px-5"
    />
  </PDPStickyNav>
);

export default MeaterProductNav;
